// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikCheckbox } from "src/components/Forms/Checkbox";
import { status } from "src/constants/account";
import { CheckboxStyle, RemoveIcon } from "../../../Wrapper";
import { FormikProps } from "formik";

interface Props {
  formProps: FormikProps<any>;
  clearFilterKey: (key: string) => void;
}

const Status: React.FC<Props> = ({ formProps, clearFilterKey }) => {
  let isVisible = false;

  if ((formProps?.values?.status || []).length > 0) {
    isVisible = true;
  }

  return (
    <Field
      label="Status:"
      mb={20}
      color="black"
      isBeside={true}
      extra={
        isVisible && (
          <RemoveIcon
            type="close-circle"
            onClick={() => {
              formProps?.setFieldValue("status", []);
              clearFilterKey("status");
            }}
            style={{ marginTop: "-2px", marginLeft: "12px" }}
          />
        )
      }
      id="status"
    >
      <FormikCheckbox name="status" data={status} style={CheckboxStyle} />
    </Field>
  );
};

export default Status;
